import { createKeyboardInput, type SharedEventLoop } from '@databases/selections';

import { SelectionFeatureKeys, type SelectionInputFeature } from '../../features/types';

export interface KeyboardInputFeatureDeps {
  sharedLoop: SharedEventLoop;
}

export function createKeyboardInputFeature(
  deps: KeyboardInputFeatureDeps
): SelectionInputFeature {
  return {
    key: SelectionFeatureKeys.KEYBOARD_INPUT,
    type: 'input',
    // Always active — keyboard input is fundamental to the selections machine.
    factory: (machine) => createKeyboardInput(machine, deps.sharedLoop),
  };
}
